<template>
	<core-pagination
		class="omapi-campaign-table__pagination"
		:perPage="perPage"
		:pageTotal="campaigns.length"
		:total="totalFilteredCampaignsCount"
		:page="page"
		@changePage="changePage"
	/>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { perPage } from '@/campaigns/store/actions'
const { mapState, mapActions } = createNamespacedHelpers('campaigns')

export default  {
	computed : {
		...mapState([ 'page', 'campaigns', 'totalFilteredCampaignsCount' ]),
		totalPages () {
			return Math.ceil(this.totalFilteredCampaignsCount / perPage)
		},
		perPage () {
			return perPage
		},
	},
	methods : {
		...mapActions([ 'goToPage' ]),
		changePage (page) {
			if (page <= this.totalPages && 0 < page) {
				this.goToPage({ page })
			}
		},
	},
}
</script>
